import { boolean, object, string } from '@/utils/validations';

export default object({
  trucker: object({
    cpf: string().cpf().required(),
    name: string().name().required(),
    fatherName: string().fatherName(),
    motherName: string()
      .when({ is: (motherName: string) => !motherName.includes('*'), then: (schema) => schema.motherName() })
      .required(),
    birthday: string().required(),
    cellPhone: string().cellPhone().required(),
    truckerIsActive: boolean().when('isRegistered', { is: true, then: (schema) => schema.isTrue() }),
    cnh: object({
      category: string().required(),
      dateFirstLicense: string().cnhFirstLicense().required(),
      expirationDate: string().cnhExpirationDate().required(),
      registrationNumber: string().cnh().required().length(11),
      securityNumber: string().required().length(11),
      stateEmission: string().required(),
    }),
    address: object({
      number: string(),
      complement: string(),
      neighborhood: string(),
      location: object().required(),
      street: string().required(),
      zipCode: string().zipCode().required(),
    }),
  }),
});
